import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Logger from "./log";
import { isZlj, loadJS } from "./common";
import { zzsdk } from "./initLoadSdk";
// 定义支持状态的枚举类型
var SupportStatus = /*#__PURE__*/function (SupportStatus) {
  SupportStatus["UNKNOWN"] = "unknown";
  SupportStatus["SUPPORTED"] = "supported";
  SupportStatus["UNSUPPORTED"] = "unsupported";
  return SupportStatus;
}(SupportStatus || {}); // 初始化为未知状态
var support = SupportStatus.UNKNOWN;

// 判断是否支持指定方法
var checkSupport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(support !== SupportStatus.UNKNOWN)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", support === SupportStatus.SUPPORTED);
        case 2:
          if (!(window && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos))) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", new Promise(function (resolve) {
            window.__ZZAPP__.hasSupportFeature({
              method: method
            }, function (res) {
              if (res && res.code === '1') {
                support = SupportStatus.SUPPORTED;
                resolve(true);
              } else {
                support = SupportStatus.UNSUPPORTED;
                resolve(false);
              }
            });
          }));
        case 6:
          support = SupportStatus.UNSUPPORTED;
          return _context.abrupt("return", false);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkSupport(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 获取指定方法的参数
var getParams = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(method) {
    var isSupport;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return checkSupport(method);
        case 3:
          isSupport = _context2.sent;
          if (isSupport) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", {});
        case 6:
          return _context2.abrupt("return", new Promise(function (resolve) {
            if (window[method]) {
              resolve(window[method]);
            } else {
              window.__ZZAPP__.run(method, {}, function (res) {
                if (res && res.code === '0') {
                  delete res.code;
                  delete res.debugMsg;
                  delete res.msg;
                  window[method] = res;
                  resolve(res);
                } else {
                  resolve({});
                }
              });
            }
          }));
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          Logger.error("\u83B7\u53D6".concat(method, "\u51FA\u9519\uFF1A").concat(_context2.t0));
          return _context2.abrupt("return", {});
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return function getParams(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

// 获取通用参数
var getZljCommon = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if (isZlj()) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", {});
        case 3:
          return _context3.abrupt("return", getParams('getLegoCommonParam'));
        case 6:
          _context3.prev = 6;
          _context3.t0 = _context3["catch"](0);
          Logger.error("\u83B7\u53D6getLegoCommonParam\u51FA\u9519\uFF1A".concat(_context3.t0));
          return _context3.abrupt("return", {});
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return function getZljCommon() {
    return _ref3.apply(this, arguments);
  };
}();

// 获取备份参数
var getLegoBackUp = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          if (isZlj()) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return", {});
        case 3:
          return _context4.abrupt("return", getParams('getLegoBackUpParam'));
        case 6:
          _context4.prev = 6;
          _context4.t0 = _context4["catch"](0);
          Logger.error("\u83B7\u53D6getLegoBackUpParam\u51FA\u9519\uFF1A".concat(_context4.t0));
          return _context4.abrupt("return", {});
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 6]]);
  }));
  return function getLegoBackUp() {
    return _ref4.apply(this, arguments);
  };
}();

// 同时执行两个函数
var getZljParams = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getZljCommonParams();
        case 2:
          _context5.next = 4;
          return getLegoBackUpParams();
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getZljParams() {
    return _ref5.apply(this, arguments);
  };
}();

// 包装函数
var getZljCommonParams = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", new Promise( /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve, reject) {
              var resfun;
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) switch (_context7.prev = _context7.next) {
                  case 0:
                    try {
                      resfun = /*#__PURE__*/function () {
                        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                          var res;
                          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                            while (1) switch (_context6.prev = _context6.next) {
                              case 0:
                                _context6.next = 2;
                                return getZljCommon();
                              case 2:
                                res = _context6.sent;
                                resolve(res);
                              case 4:
                              case "end":
                                return _context6.stop();
                            }
                          }, _callee6);
                        }));
                        return function resfun() {
                          return _ref8.apply(this, arguments);
                        };
                      }();
                      if (window.__ZZAPP__) {
                        resfun();
                      } else {
                        loadJS(zzsdk, resfun);
                      }
                    } catch (error) {
                      Logger.error(error);
                      reject({});
                    }
                  case 1:
                  case "end":
                    return _context7.stop();
                }
              }, _callee7);
            }));
            return function (_x3, _x4) {
              return _ref7.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getZljCommonParams() {
    return _ref6.apply(this, arguments);
  };
}();
var getLegoBackUpParams = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", new Promise( /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(resolve, reject) {
              var resfun;
              return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    try {
                      resfun = /*#__PURE__*/function () {
                        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                          var res;
                          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                            while (1) switch (_context9.prev = _context9.next) {
                              case 0:
                                _context9.next = 2;
                                return getLegoBackUp();
                              case 2:
                                res = _context9.sent;
                                resolve(res);
                              case 4:
                              case "end":
                                return _context9.stop();
                            }
                          }, _callee9);
                        }));
                        return function resfun() {
                          return _ref11.apply(this, arguments);
                        };
                      }();
                      if (window.__ZZAPP__) {
                        resfun();
                      } else {
                        loadJS(zzsdk, resfun);
                      }
                    } catch (error) {
                      Logger.error(error);
                      reject({});
                    }
                  case 1:
                  case "end":
                    return _context10.stop();
                }
              }, _callee10);
            }));
            return function (_x5, _x6) {
              return _ref10.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getLegoBackUpParams() {
    return _ref9.apply(this, arguments);
  };
}();
export { getZljCommonParams, getLegoBackUpParams, getZljParams };